export default [
    // {
    //     path: '/hours',
    //     name: 'hours',
    //     component: () => import ('./pages/Index')
    // },
]